function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 24 24",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M15.33,10.66c-0.01,2.57-2.09,4.65-4.66,4.66c-1.24,0.03-2.43-0.45-3.3-1.33c-0.9-0.87-1.4-2.08-1.37-3.33  c-0.02-1.24,0.48-2.44,1.37-3.3c0.86-0.89,2.06-1.39,3.3-1.37c1.25-0.03,2.46,0.47,3.33,1.37c0.89,0.86,1.39,2.06,1.37,3.3l0,0  H15.33z M20.66,19.32c0.01-0.35-0.14-0.69-0.39-0.94l-3.57-3.57c0.85-1.21,1.31-2.67,1.3-4.15c0-0.98-0.19-1.95-0.58-2.85  c-0.73-1.77-2.13-3.17-3.9-3.9c-1.82-0.77-3.88-0.77-5.7,0c-1.77,0.73-3.17,2.13-3.9,3.9c-0.77,1.82-0.77,3.88,0,5.7  c0.73,1.77,2.13,3.17,3.9,3.9c0.9,0.39,1.87,0.58,2.85,0.58c1.48,0.01,2.93-0.44,4.15-1.29l3.57,3.56c0.24,0.26,0.58,0.41,0.94,0.4  C20.06,20.65,20.65,20.06,20.66,19.32L20.66,19.32L20.66,19.32z",
    style: {
      fill: "rgb(21, 21, 21)"
    },
    vectorEffect: "non-scaling-stroke"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBold);
export default __webpack_public_path__ + "static/media/search-bold.50c4ff8c.svg";
export { ForwardRef as ReactComponent };